import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import styled from 'styled-components';

import {
  scale110,
  scale130,
  spaceL,
  spaceS,
  spaceXL,
  xdlColorText,
} from '@xing-com/tokens';

import { XingQuoteIcon } from './xing-quote-icon';

const XingQuoteWrapper = styled.div`
  display: flex;
`;

const StyledNodeViewContent = styled(NodeViewContent)`
  &.xing-quote-content {
    flex: 1;
    margin: 0 0 0 ${spaceXL};

    blockquote.node-quote {
      margin: 0 0 ${spaceS} 0;
      padding: 0;
      border-left: 0;
      font-size: ${scale110};
      font-weight: bold;
      line-height: ${scale130};
    }

    .node-quoteCaption {
      color: ${xdlColorText};
      font-size: ${spaceL};
      font-style: normal;
      font-weight: bold;
      line-height: 26px;
    }
  }
`;

const StyledXingQuoteIcon = styled(XingQuoteIcon)`
  fill: ${xdlColorText};
`;

export const XingQuoteView: React.FC = () => {
  return (
    <NodeViewWrapper className="react-component">
      <XingQuoteWrapper>
        <StyledXingQuoteIcon />
        <StyledNodeViewContent className="xing-quote-content" />
      </XingQuoteWrapper>
    </NodeViewWrapper>
  );
};
